// Mirrors CAIMS.Shared.Constants.FilterAssetType
export enum FilterAssetType {
    Building = 0,
    Pole = 1,
    Substation = 2,
    CimSubstation = 3
}
